export default {"src":"/_next/static/media/vendor-privacy-management.6f3afcad.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};